// @ts-nocheck
import ReactDOM from 'react-dom/client';
import './index.css';
import CustomAuthenticator from './custom-authenticator';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CustomAuthenticator />
);

reportWebVitals();
